import React from 'react';
import * as styles from '../styles/SweetAlertStyles';
var defaultStyle = Object.assign({}, styles.icon, styles.iconCustom);
var CustomIcon = function (_a) {
    var iconUrl = _a.iconUrl;
    var backgroundImage = "url(" + iconUrl;
    var style = Object.assign({}, defaultStyle, { backgroundImage: backgroundImage });
    return React.createElement("div", { style: style });
};
export default CustomIcon;
//# sourceMappingURL=CustomIcon.js.map